import React from 'react'
import Link from 'gatsby-link'
import Divider from '../Divider/Divider'
import styles from './IconGrid.module.css'
import Inner from '../Inner/Inner'
import Handshake from '-!babel!svg-react-loader?name=Handshake!../../../static/assets/handshake.svg'
import Backup from '-!babel!svg-react-loader?name=Backup!../../../static/assets/backup.svg'
import Consulting from '-!babel!svg-react-loader?name=Consulting!../../../static/assets/consulting.svg'
import Disaster from '-!babel!svg-react-loader?name=Disaster!../../../static/assets/disaster-recovery.svg'
import Networking from '-!babel!svg-react-loader?name=Networking!../../../static/assets/networking5.svg'
import Globe from '-!babel!svg-react-loader?name=Globe!../../../static/assets/globe.svg'
import Firewall from '-!babel!svg-react-loader?name=Firewall!../../../static/assets/firewall.svg'
import Server from '-!babel!svg-react-loader?name=Server!../../../static/assets/server.svg'
import Audit from '-!babel!svg-react-loader?name=Audit!../../../static/assets/audit2.svg'
import Virtualization from '-!babel!svg-react-loader?name=Virtualization!../../../static/assets/virtualization.svg'
import Consolidation from '-!babel!svg-react-loader?name=Consolidation!../../../static/assets/consolidation.svg'
import Workstations from '-!babel!svg-react-loader?name=Workstations!../../../static/assets/workstations.svg'
import DataRecovery from '-!babel!svg-react-loader?name=Workstations!../../../static/assets/data-recovery.svg'
import SecureDelete from '-!babel!svg-react-loader?name=Workstations!../../../static/assets/secure-data-delete.svg'
import Ransom from '-!babel!svg-react-loader?name=Workstations!../../../static/assets/ransom.svg'

const IconGrid = props => {
  const icons = props.items.map(item => {
    function theIcon(item) {
      const rawIcon = item.node.childMarkdownRemark.frontmatter.icon
      if (rawIcon == '/assets/secure-data-delete.svg') {
        return <SecureDelete />
      }
      if (rawIcon == '/assets/data-recovery.svg') {
        return <DataRecovery />
      }
      if (rawIcon == '/assets/handshake.svg') {
        return <Handshake />
      }
      if (rawIcon == '/assets/backup.svg') {
        return <Backup />
      }
      if (rawIcon == '/assets/consulting.svg') {
        return <Consulting />
      }
      if (rawIcon == '/assets/disaster-recovery.svg') {
        return <Disaster />
      }
      if (rawIcon == '/assets/networking5.svg') {
        return <Networking />
      }
      if (rawIcon == '/assets/globe.svg') {
        return <Globe />
      }
      if (rawIcon == '/assets/firewall.svg') {
        return <Firewall />
      }
      if (rawIcon == '/assets/server.svg') {
        return <Server />
      }
      if (rawIcon == '/assets/audit2.svg') {
        return <Audit />
      }
      if (rawIcon == '/assets/virtualization.svg') {
        return <Virtualization />
      }
      if (rawIcon == '/assets/consolidation.svg') {
        return <Consolidation />
      }
      if (rawIcon == '/assets/workstations.svg') {
        return <Workstations />
      }
      if (rawIcon == '/assets/ransom.svg') {
        return <Ransom />
      }
    }
    return (
      <li key={item.node.id}>
        <Link to={`/solutions${item.node.childMarkdownRemark.fields.slug}`}>
          {theIcon(item)}
          <h2 className={styles.itemHeading}>
            {item.node.childMarkdownRemark.frontmatter.title}
          </h2>
        </Link>
      </li>
    )
  })

  return (
    <div className={styles.wrapper}>
      <Inner>
        <h1 className={styles.heading}>{props.heading}</h1>
        <ul className={styles.items}>{icons}</ul>
      </Inner>
    </div>
  )
}

export default IconGrid



// WEBPACK FOOTER //
// ./src/components/IconGrid/IconGrid.js